<template>
    <div>
        <v-row>
            <v-col cols="12" class="mb-3 mar-t-10 text-right">
                <v-btn rounded color="amber" @click="open_cso()">
                    <v-icon class="mr-1">mdi-near-me</v-icon> Return e-CSO
                </v-btn>
            </v-col>
        </v-row>
        <div class="no-pd mar-t-10">
            <v-tabs
                v-model="tab"
                background-color="blue accent-2"
                color="lime accent-2"
                class="elevation-2"
                dark
                :grow="true"
            >
                <v-tab
                    v-for="i in tabs_name.length"
                    :key="i"
                    @click="change_tab(tabs_name[i - 1])"
                >
                    <v-icon class="mr-1" v-if="tabs_name[i - 1] === actibe_tab"
                        >mdi-checkbox-marked-circle</v-icon
                    >
                    {{ tabs_name[i - 1] }}
                </v-tab>
            </v-tabs>

            <v-tabs-items touchless v-model="tab">
                <v-tab-item
                    v-for="i in tabs_name.length"
                    :key="i"
                    :href="`#tab-${i}`"
                >
                    <div>
                        <!-- TAB 1 -->
                        <div v-if="i === 1">
                            <v-row>
                                <v-col
                                    cols="12"
                                    v-if="
                                        data_main_hp && data_main_hp.length > 0
                                    "
                                >
                                    <b class="ml-4"
                                        >HP
                                        <span class="red--text ml-2"
                                            >**ใบงาน HP
                                            ให้ทางช่างส่งคืนส่วนกลางทั้ง 2 ใบ
                                            คือใบสีขาว และสีเหลือง
                                            เนื่องจากเราเข้าสู่กระบวนการ ISO
                                            27001</span
                                        ></b
                                    >

                                    <v-col class="text-right" cols="12" md="2">
                                        <v-btn
                                            color="success"
                                            block
                                            @click="save_return_hp()"
                                            :disabled="!checkbox_hp.length > 0"
                                            ><v-icon small class="mr-1"
                                                >mdi-content-save</v-icon
                                            >
                                            Save Pending Return :
                                            {{ checkbox_hp.length }}</v-btn
                                        >
                                    </v-col>
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        <v-btn
                                                            :disabled="
                                                                checkbox.length >
                                                                    0 ||
                                                                checkbox_sub.length >
                                                                    0 ||
                                                                checkbox_mps.length >
                                                                    0 ||
                                                                checkbox_oki.length >
                                                                    0 ||
                                                                checkbox_svc.length >
                                                                    0
                                                            "
                                                            small
                                                            :color="colorx_hp"
                                                            @click="all_hp()"
                                                            rounded
                                                            >All</v-btn
                                                        >
                                                    </th>
                                                    <!-- <th class="text-center">
                                                        #
                                                    </th> -->
                                                    <th class="text-center">
                                                        Project
                                                    </th>

                                                    <th class="text-center">
                                                        Date on site
                                                    </th>

                                                    <th class="text-center">
                                                        Case ID
                                                    </th>
                                                    <th class="text-center">
                                                        Product Serial
                                                    </th>
                                                    <th class="text-center">
                                                        Cso No.
                                                    </th>
                                                    <th class="text-center">
                                                        Case Title
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    class="text-center"
                                                    v-for="(
                                                        r, i
                                                    ) in data_main_hp"
                                                    :key="i"
                                                >
                                                    <td>
                                                        <v-switch
                                                            :disabled="
                                                                checkbox.length >
                                                                    0 ||
                                                                checkbox_sub.length >
                                                                    0 ||
                                                                checkbox_mps.length >
                                                                    0 ||
                                                                checkbox_oki.length >
                                                                    0 ||
                                                                checkbox_svc.length >
                                                                    0
                                                            "
                                                            v-model="
                                                                checkbox_hp
                                                            "
                                                            :value="
                                                                r.subcase_id
                                                            "
                                                        ></v-switch>
                                                    </td>
                                                    <!-- <td>{{ i + 1 }}.</td> -->
                                                    <td>
                                                        {{ r.project_name }}
                                                    </td>
                                                    <td>{{ r.onsite_at }}</td>
                                                    <td>{{ r.case_id }}</td>
                                                    <td>
                                                        {{ r.product_serial }}
                                                    </td>
                                                    <td>{{ r.csono }}</td>
                                                    <td class="text-left">
                                                        <span
                                                            class="font-fix-13"
                                                            >{{
                                                                r.case_title
                                                            }}</span
                                                        >
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr class="fix-hr-1" />
                                </v-col>

                                <v-col class="text-right" cols="12" md="2">
                                    <v-btn
                                        color="success"
                                        block
                                        @click="save_return()"
                                        :disabled="!checkbox.length > 0"
                                        ><v-icon small class="mr-1"
                                            >mdi-content-save</v-icon
                                        >
                                        Save Pending Return :
                                        {{ checkbox.length }}</v-btn
                                    >
                                </v-col>
                                <!-- <div style="width: 100%; height: 100px; overflow-y: scroll;">  x   </div>-->
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        <v-btn
                                                            :disabled="
                                                                checkbox_hp.length >
                                                                    0 ||
                                                                checkbox_sub.length >
                                                                    0 ||
                                                                checkbox_mps.length >
                                                                    0 ||
                                                                checkbox_oki.length >
                                                                    0 ||
                                                                checkbox_svc.length >
                                                                    0
                                                            "
                                                            small
                                                            :color="colorx"
                                                            @click="all()"
                                                            rounded
                                                            >All</v-btn
                                                        >
                                                    </th>
                                                    <!-- <th class="text-center">
                                                        #
                                                    </th> -->
                                                    <th class="text-center">
                                                        Project
                                                    </th>
                                                    <th class="text-center">
                                                        Case ID Sub
                                                    </th>
                                                    <th class="text-center">
                                                        Product Serial
                                                    </th>
                                                    <th class="text-center">
                                                        Date on site
                                                    </th>
                                                    <th class="text-center">
                                                        Cso No.
                                                    </th>
                                                    <th class="text-center">
                                                        Site Name
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    class="text-center"
                                                    v-for="(
                                                        row, index
                                                    ) in data_main"
                                                    :key="index"
                                                >
                                                    <td>
                                                        <v-switch
                                                            :disabled="
                                                                checkbox_hp.length >
                                                                    0 ||
                                                                checkbox_sub.length >
                                                                    0 ||
                                                                checkbox_mps.length >
                                                                    0 ||
                                                                checkbox_oki.length >
                                                                    0 ||
                                                                checkbox_svc.length >
                                                                    0
                                                            "
                                                            v-model="checkbox"
                                                            :value="
                                                                row.subcase_id
                                                            "
                                                        ></v-switch>
                                                    </td>
                                                    <!-- <td>{{ index + 1 }}.</td> -->
                                                    <td>
                                                        {{ row.project_name }}
                                                    </td>
                                                    <td>
                                                        {{ row.case_id }} -
                                                        {{ row.subcase }}
                                                    </td>
                                                    <td>
                                                        {{ row.product_serial }}
                                                    </td>
                                                    <td>{{ row.onsite_at }}</td>
                                                    <td>{{ row.csono }}</td>
                                                    <td class="text-left">
                                                        <span
                                                            class="font-fix-13"
                                                            >{{
                                                                row.site_name
                                                            }}</span
                                                        >
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr class="fix-hr-1" />
                                </v-col>

                                <v-col
                                    cols="12"
                                    v-if="
                                        data_main_sub &&
                                        data_main_sub.length > 0
                                    "
                                >
                                    <!-- v-if="data_main_sub && data_main_sub.length > 0" -->
                                    <b class="ml-4">ODM</b>
                                    <v-col class="text-right" cols="12" md="2">
                                        <v-btn
                                            color="success"
                                            block
                                            @click="save_return_sub()"
                                            :disabled="!checkbox_sub.length > 0"
                                            ><v-icon small class="mr-1"
                                                >mdi-content-save</v-icon
                                            >
                                            Save Pending Return :
                                            {{ checkbox_sub.length }}</v-btn
                                        >
                                    </v-col>
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        <v-btn
                                                            :disabled="
                                                                checkbox.length >
                                                                    0 ||
                                                                checkbox_hp.length >
                                                                    0 ||
                                                                checkbox_mps.length >
                                                                    0 ||
                                                                checkbox_oki.length >
                                                                    0 ||
                                                                checkbox_svc.length >
                                                                    0
                                                            "
                                                            small
                                                            :color="colorx_sub"
                                                            @click="all_sub()"
                                                            rounded
                                                            >All</v-btn
                                                        >
                                                    </th>
                                                    <!-- <th class="text-center">
                                                        #
                                                    </th> -->
                                                    <th class="text-center">
                                                        Project
                                                    </th>

                                                    <th class="text-center">
                                                        Date on site
                                                    </th>

                                                    <th class="text-center">
                                                        Case ID
                                                    </th>
                                                    <th class="text-center">
                                                        Product Serial
                                                    </th>

                                                    <th class="text-center">
                                                        Cso No.
                                                    </th>
                                                    <th class="text-center">
                                                        Case Title
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    class="text-center"
                                                    v-for="(
                                                        r, i
                                                    ) in data_main_sub"
                                                    :key="i"
                                                >
                                                    <td>
                                                        <v-switch
                                                            :disabled="
                                                                checkbox_hp.length >
                                                                    0 ||
                                                                checkbox.length >
                                                                    0 ||
                                                                checkbox_mps.length >
                                                                    0 ||
                                                                checkbox_oki.length >
                                                                    0 ||
                                                                checkbox_svc.length >
                                                                    0
                                                            "
                                                            v-model="
                                                                checkbox_sub
                                                            "
                                                            :value="
                                                                r.subcase_id
                                                            "
                                                        ></v-switch>
                                                    </td>
                                                    <!-- <td>{{ i + 1 }}.</td> -->
                                                    <td>
                                                        {{ r.project_name }}
                                                    </td>
                                                    <td>{{ r.onsite_at }}</td>
                                                    <td>{{ r.case_id }}</td>
                                                    <td>
                                                        {{ r.product_serial }}
                                                    </td>
                                                    <td>{{ r.csono }}</td>
                                                    <td class="text-left">
                                                        <span
                                                            class="font-fix-13"
                                                            >{{
                                                                r.case_title
                                                            }}</span
                                                        >
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr class="fix-hr-1" />
                                </v-col>

                                <v-col
                                    cols="12"
                                    v-if="
                                        data_main_mps &&
                                        data_main_mps.length > 0
                                    "
                                >
                                    <b class="ml-4">MPS</b>
                                    <v-col class="text-right" cols="12" md="2">
                                        <v-btn
                                            color="success"
                                            block
                                            @click="save_return_mps()"
                                            :disabled="!checkbox_mps.length > 0"
                                            ><v-icon small class="mr-1"
                                                >mdi-content-save</v-icon
                                            >
                                            Save Pending Return :
                                            {{ checkbox_mps.length }}</v-btn
                                        >
                                    </v-col>
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        <v-btn
                                                            :disabled="
                                                                checkbox.length >
                                                                    0 ||
                                                                checkbox_sub.length >
                                                                    0 ||
                                                                checkbox_hp.length >
                                                                    0 ||
                                                                checkbox_oki.length >
                                                                    0 ||
                                                                checkbox_svc.length >
                                                                    0
                                                            "
                                                            small
                                                            :color="colorx_mps"
                                                            @click="all_mps()"
                                                            rounded
                                                            >All</v-btn
                                                        >
                                                    </th>
                                                    <!-- <th class="text-center">
                                                        #
                                                    </th> -->
                                                    <th class="text-center">
                                                        Project
                                                    </th>

                                                    <th class="text-center">
                                                        Date on site
                                                    </th>

                                                    <th class="text-center">
                                                        Case ID
                                                    </th>
                                                    <th class="text-center">
                                                        Product Serial
                                                    </th>
                                                    <th class="text-center">
                                                        Cso No.
                                                    </th>
                                                    <th class="text-center">
                                                        Case Title
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    class="text-center"
                                                    v-for="(
                                                        r, i
                                                    ) in data_main_mps"
                                                    :key="i"
                                                >
                                                    <td>
                                                        <v-switch
                                                            :disabled="
                                                                checkbox_hp.length >
                                                                    0 ||
                                                                checkbox_sub.length >
                                                                    0 ||
                                                                checkbox.length >
                                                                    0 ||
                                                                checkbox_oki.length >
                                                                    0 ||
                                                                checkbox_svc.length >
                                                                    0
                                                            "
                                                            v-model="
                                                                checkbox_mps
                                                            "
                                                            :value="
                                                                r.subcase_id
                                                            "
                                                        ></v-switch>
                                                    </td>
                                                    <!-- <td>{{ i + 1 }}.</td> -->
                                                    <td>
                                                        {{ r.project_name }}
                                                    </td>
                                                    <td>{{ r.onsite_at }}</td>
                                                    <td>{{ r.case_id }}</td>
                                                    <td>
                                                        {{ r.product_serial }}
                                                    </td>
                                                    <td>{{ r.csono }}</td>
                                                    <td class="text-left">
                                                        <span
                                                            class="font-fix-13"
                                                            >{{
                                                                r.case_title
                                                            }}</span
                                                        >
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr class="fix-hr-1" />
                                </v-col>

                                <v-col
                                    cols="12"
                                    v-if="
                                        data_main_oki &&
                                        data_main_oki.length > 0
                                    "
                                >
                                    <b class="ml-4">OKI</b>
                                    <v-col class="text-right" cols="12" md="2">
                                        <v-btn
                                            color="success"
                                            block
                                            @click="save_return_oki()"
                                            :disabled="!checkbox_oki.length > 0"
                                            ><v-icon small class="mr-1"
                                                >mdi-content-save</v-icon
                                            >
                                            Save Pending Return :
                                            {{ checkbox_oki.length }}</v-btn
                                        >
                                    </v-col>
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        <v-btn
                                                            :disabled="
                                                                checkbox.length >
                                                                    0 ||
                                                                checkbox_sub.length >
                                                                    0 ||
                                                                checkbox_mps.length >
                                                                    0 ||
                                                                checkbox_hp.length >
                                                                    0 ||
                                                                checkbox_svc.length >
                                                                    0
                                                            "
                                                            small
                                                            :color="colorx_oki"
                                                            @click="all_oki()"
                                                            rounded
                                                            >All</v-btn
                                                        >
                                                    </th>
                                                    <!-- <th class="text-center">
                                                        #
                                                    </th> -->
                                                    <th class="text-center">
                                                        Project
                                                    </th>
                                                    <th class="text-center">
                                                        Case ID Sub
                                                    </th>
                                                    <th class="text-center">
                                                        Product Serial
                                                    </th>
                                                    <th class="text-center">
                                                        Date on site
                                                    </th>
                                                    <th class="text-center">
                                                        Cso No.
                                                    </th>
                                                    <th class="text-center">
                                                        Site Name
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    class="text-center"
                                                    v-for="(
                                                        r, i
                                                    ) in data_main_oki"
                                                    :key="i"
                                                >
                                                    <td>
                                                        <v-switch
                                                            :disabled="
                                                                checkbox_hp.length >
                                                                    0 ||
                                                                checkbox_sub.length >
                                                                    0 ||
                                                                checkbox_mps.length >
                                                                    0 ||
                                                                checkbox.length >
                                                                    0 ||
                                                                checkbox_svc.length >
                                                                    0
                                                            "
                                                            v-model="
                                                                checkbox_oki
                                                            "
                                                            :value="
                                                                r.subcase_id
                                                            "
                                                        ></v-switch>
                                                    </td>
                                                    <!-- <td>{{ i + 1 }}.</td> -->
                                                    <td>
                                                        {{ r.project_name }}
                                                    </td>
                                                    <td>
                                                        {{ r.case_id }} -
                                                        {{ r.subcase }}
                                                    </td>
                                                    <td>
                                                        {{ r.product_serial }}
                                                    </td>
                                                    <td>{{ r.onsite_at }}</td>
                                                    <td>{{ r.csono }}</td>
                                                    <td class="text-left">
                                                        <span
                                                            class="font-fix-13"
                                                            >{{
                                                                r.site_name
                                                            }}</span
                                                        >
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr class="fix-hr-1" />
                                </v-col>

                                <v-col
                                    cols="12"
                                    v-if="
                                        data_main_svc &&
                                        data_main_svc.length > 0
                                    "
                                >
                                    <b class="ml-4">SVC</b>
                                    <v-col class="text-right" cols="12" md="2">
                                        <v-btn
                                            color="success"
                                            block
                                            @click="save_return_svc()"
                                            :disabled="!checkbox_svc.length > 0"
                                            ><v-icon small class="mr-1"
                                                >mdi-content-save</v-icon
                                            >
                                            Save Pending Return :
                                            {{ checkbox_svc.length }}</v-btn
                                        >
                                    </v-col>
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        <v-btn
                                                            :disabled="
                                                                checkbox.length >
                                                                    0 ||
                                                                checkbox_sub.length >
                                                                    0 ||
                                                                checkbox_mps.length >
                                                                    0 ||
                                                                checkbox_oki.length >
                                                                    0 ||
                                                                checkbox_hp.length >
                                                                    0
                                                            "
                                                            small
                                                            :color="colorx_svc"
                                                            @click="all_svc()"
                                                            rounded
                                                            >All</v-btn
                                                        >
                                                    </th>
                                                    <!-- <th class="text-center">
                                                        #
                                                    </th> -->
                                                    <th class="text-center">
                                                        Project
                                                    </th>
                                                    <th class="text-center">
                                                        Case ID Sub
                                                    </th>
                                                    <th class="text-center">
                                                        Product Serial
                                                    </th>
                                                    <th class="text-center">
                                                        Date on site
                                                    </th>
                                                    <th class="text-center">
                                                        Cso No.
                                                    </th>
                                                    <th class="text-center">
                                                        Site Name
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    class="text-center"
                                                    v-for="(
                                                        r, i
                                                    ) in data_main_svc"
                                                    :key="i"
                                                >
                                                    <td>
                                                        <v-switch
                                                            :disabled="
                                                                checkbox_hp.length >
                                                                    0 ||
                                                                checkbox_sub.length >
                                                                    0 ||
                                                                checkbox_mps.length >
                                                                    0 ||
                                                                checkbox_oki.length >
                                                                    0 ||
                                                                checkbox.length >
                                                                    0
                                                            "
                                                            v-model="
                                                                checkbox_svc
                                                            "
                                                            :value="
                                                                r.subcase_id
                                                            "
                                                        ></v-switch>
                                                    </td>
                                                    <!-- <td>{{ i + 1 }}.</td> -->
                                                    <td>
                                                        {{ r.project_name }}
                                                    </td>
                                                    <td>
                                                        {{ r.case_id }} -
                                                        {{ r.subcase }}
                                                    </td>
                                                    <td>
                                                        {{ r.product_serial }}
                                                    </td>
                                                    <td>{{ r.onsite_at }}</td>
                                                    <td>{{ r.csono }}</td>
                                                    <td class="text-left">
                                                        <span
                                                            class="font-fix-13"
                                                            >{{
                                                                r.site_name
                                                            }}</span
                                                        >
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr class="fix-hr-1" />
                                </v-col>
                            </v-row>
                        </div>

                        <!-- TAB 2 -->
                        <div v-if="i === 2">
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        #
                                                    </th>
                                                    <th class="text-center">
                                                        Doc No.
                                                    </th>
                                                    <th class="text-center">
                                                        Doc Status
                                                    </th>
                                                    <th class="text-center">
                                                        Send To
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    class="text-center"
                                                    v-for="(
                                                        row, index
                                                    ) in data_main"
                                                    :key="index"
                                                >
                                                    <td>{{ index + 1 }}.</td>
                                                    <td>
                                                        <v-btn
                                                            small
                                                            @click="
                                                                print_send(
                                                                    row.doc_no
                                                                )
                                                            "
                                                            >{{
                                                                row.doc_no
                                                            }}</v-btn
                                                        >
                                                    </td>
                                                    <td>
                                                        {{ row.doc_status }}
                                                    </td>
                                                    <td class="text-center">
                                                        <v-chip
                                                            x-small
                                                            color="amber"
                                                            class="mb-1"
                                                            >{{
                                                                row.doc_to
                                                            }}</v-chip
                                                        >
                                                        <br />
                                                        <v-chip x-small>{{
                                                            row.created_date
                                                        }}</v-chip>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr class="fix-hr-1" />
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </div>

        <v-dialog
            v-model="dialog_cso"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="close_cso()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-row class="mt-5">
                        <v-col cols="8" md="4">
                            <v-text-field
                                v-model="form_cso.case_id"
                                small
                                outlined
                                label="Search Case ID"
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-btn
                                dense
                                color="primary"
                                rounded
                                :disabled="form_cso.case_id == ''"
                                @click="serch_doc_cso()"
                            >
                                <v-icon class="mr-1">mdi-plus</v-icon>
                                Search Case
                            </v-btn>
                        </v-col>
                        <v-col cols="12" class="mar-t-20">
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th class="text-center">#</th>
                                            <th class="text-center">Case</th>
                                            <th class="text-center">
                                                Solution
                                            </th>
                                            <th class="text-center">csono</th>
                                            <th class="text-center">
                                                Onsite Date
                                            </th>
                                            <th class="text-center">Del.</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(row, index) in arr_cso"
                                            :key="index"
                                        >
                                            <td class="text-center">
                                                {{ index + 1 }}.
                                            </td>
                                            <td>
                                                <v-btn
                                                    class="mt-2 mb-1 mr-1"
                                                    :to="
                                                        '/Project/ViewCasepending/' +
                                                        team_name +
                                                        '/' +
                                                        row.maincase_id +
                                                        '/ViewDetail'
                                                    "
                                                    target="_blank"
                                                    small
                                                    color="white"
                                                    rounded
                                                >
                                                    <span
                                                        class="primary--text mr-1"
                                                        >{{
                                                            row.case_id +
                                                            "-" +
                                                            row.subcase
                                                        }}
                                                    </span>
                                                </v-btn>
                                                <br />
                                                <v-chip
                                                    small
                                                    color="primary"
                                                    class="mr-1 mb-2"
                                                >
                                                    {{ row.project_name }}
                                                </v-chip>
                                                <span class="font-b mb-2">
                                                    {{ row.site_name }}
                                                </span>
                                            </td>
                                            <td class="text-center">
                                                xxx
                                                {{ row.solution }}
                                            </td>
                                            <td class="text-center">
                                                {{ row.csono }}
                                            </td>
                                            <td class="text-center">
                                                {{ row.onsite_date }}
                                            </td>
                                            <td class="text-center">
                                                <v-btn
                                                    fab
                                                    x-small
                                                    color="red lighten-1"
                                                    @click="del_arr_cso(index)"
                                                >
                                                    <v-icon>mdi-minus</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                        <br />
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                        <v-col
                            cols="12"
                            class="text-center"
                            v-if="arr_cso.length > 0"
                        >
                            <v-btn
                                rounded
                                depressed
                                @click="save_doc_cso()"
                                color="success"
                                class="white--text"
                            >
                                <v-icon class="mr-1">mdi-content-save</v-icon>
                                Save Doc Return
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/`
let url2

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
    },
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            this.mutateIsLoading()

            if (this.actibe_tab == "Pending Return") {
                url2 = "document"
            } else if (this.actibe_tab == "Sent") {
                url2 = "document/pending-receive"
            }

            // console.log(url2)

            await axios
                .get(url + url2, this.tk)
                .then((response) => {
                    this.data_main = response.data.main
                    if (response.data.sub) {
                        this.data_main_sub = response.data.sub
                    }
                    if (response.data.mps) {
                        this.data_main_mps = response.data.mps
                    }

                    if (response.data.oki) {
                        this.data_main_oki = response.data.oki
                    }

                    if (response.data.svc) {
                        this.data_main_svc = response.data.svc
                    }

                    if (response.data.svc) {
                        this.data_main_hp = response.data.hp
                    }

                    this.mutateIsLoading()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        change_tab(change_tab) {
            this.chk = false
            this.colorx = ""
            this.checkbox = []
            this.data_main = []
            this.actibe_tab = change_tab
            this.get_data()
        },
        all() {
            if (this.chk === true) {
                this.chk = false
                this.colorx = ""
                this.checkbox = []
            } else {
                this.chk = true
                this.colorx = "success"
                this.data_main.map((r) => {
                    this.checkbox.push(r.subcase_id)
                })
            }
        },
        all_sub() {
            if (this.chk_sub === true) {
                this.chk_sub = false
                this.colorx_sub = ""
                this.checkbox_sub = []
            } else {
                this.chk_sub = true
                this.colorx_sub = "success"
                this.data_main_sub.map((r) => {
                    this.checkbox_sub.push(r.subcase_id)
                })
            }
        },
        all_mps() {
            if (this.chk_mps === true) {
                this.chk_mps = false
                this.colorx_mps = ""
                this.checkbox_mps = []
            } else {
                this.chk_mps = true
                this.colorx_mps = "success"
                this.data_main_mps.map((r) => {
                    this.checkbox_mps.push(r.subcase_id)
                })
            }
        },
        all_hp() {
            if (this.chk_hp === true) {
                this.chk_hp = false
                this.colorx_hp = ""
                this.checkbox_hp = []
            } else {
                this.chk_hp = true
                this.colorx_hp = "success"
                this.data_main_hp.map((r) => {
                    this.checkbox_hp.push(r.subcase_id)
                })
            }
        },
        all_oki() {
            if (this.chk_oki === true) {
                this.chk_oki = false
                this.colorx_oki = ""
                this.checkbox_oki = []
            } else {
                this.chk_oki = true
                this.colorx_oki = "success"
                this.data_main_oki.map((r) => {
                    this.checkbox_oki.push(r.subcase_id)
                })
            }
        },

        all_svc() {
            if (this.chk_svc === true) {
                this.chk_svc = false
                this.colorx_svc = ""
                this.checkbox_svc = []
            } else {
                this.chk_svc = true
                this.colorx_svc = "success"
                this.data_main_svc.map((r) => {
                    this.checkbox_svc.push(r.subcase_id)
                })
            }
        },

        async save_return() {
            let save = {
                subcase_id: this.checkbox,
                status: "main",
            }
            await axios
                .post(url + url2, save, this.tk)
                .then((response) => {
                    this.$router.push(
                        "/Onsite/Main/Print-ReturnDocument/" +
                            response.data.doc_no +
                            "/save"
                    )
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async save_return_sub() {
            let save = {
                subcase_id: this.checkbox_sub,
                status: "sub",
            }
            await axios
                .post(url + url2, save, this.tk)
                .then((response) => {
                    this.$router.push(
                        "/Onsite/Main/Print-ReturnDocument/" +
                            response.data.doc_no +
                            "/save"
                    )
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async save_return_hp() {
            let save = {
                subcase_id: this.checkbox_hp,
                status: "hp",
            }
            await axios
                .post(url + url2, save, this.tk)
                .then((response) => {
                    this.$router.push(
                        "/Onsite/Main/Print-ReturnDocument/" +
                            response.data.doc_no +
                            "/save"
                    )
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        async save_return_mps() {
            let save = {
                subcase_id: this.checkbox_mps,
                status: "mps",
            }
            await axios
                .post(url + url2, save, this.tk)
                .then((response) => {
                    this.$router.push(
                        "/Onsite/Main/Print-ReturnDocument/" +
                            response.data.doc_no +
                            "/save"
                    )
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        async save_return_oki() {
            let save = {
                subcase_id: this.checkbox_oki,
                status: "oki",
            }
            await axios
                .post(url + url2, save, this.tk)
                .then((response) => {
                    this.$router.push(
                        "/Onsite/Main/Print-ReturnDocument/" +
                            response.data.doc_no +
                            "/save"
                    )
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        async save_return_svc() {
            let save = {
                subcase_id: this.checkbox_svc,
                status: "svc",
            }
            await axios
                .post(url + url2, save, this.tk)
                .then((response) => {
                    this.$router.push(
                        "/Onsite/Main/Print-ReturnDocument/" +
                            response.data.doc_no +
                            "/save"
                    )
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        print_send(doc_no) {
            this.$router.push(
                "/Onsite/Main/Print-ReturnDocument/" + doc_no + "/print"
            )
        },
        open_cso() {
            this.dialog_cso = true
        },
        close_cso() {
            this.arr_cso = []
            this.dialog_cso = false
        },
        async serch_doc_cso() {
            this.dialog_loading = true
            let send = {
                searchtext: this.form_cso.case_id,
            }
            await axios
                .post(url + "document/e-cso/search", send, this.tk)
                .then((response) => {
                    if (response.data.status == "ok") {
                        this.form_cso.case_id = ""
                        if (response.data.data.length == 1) {
                            this.arr_cso = [
                                ...this.arr_cso,
                                response.data.data[0],
                            ]
                        } else if (response.data.data.length > 1) {
                            response.data.data.map((r) => {
                                this.arr_cso = [...this.arr_cso, r]
                            })
                        }
                    } else {
                        this.$swal({
                            title: "Alert",
                            text: response.data.message,
                            icon: "warning",
                            button: true,
                        })
                    }
                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        del_arr_cso(i) {
            this.arr_cso.splice(i, 1)
        },
        async save_doc_cso() {
            this.dialog_loading = true
            let send = {
                case: this.arr_cso,
            }
            await axios
                .post(url + "document/e-cso/save", send, this.tk)
                .then((response) => {
                    this.mutatesnackbar()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                    this.dialog_loading = false
                    this.close_cso()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
    },
    data: () => ({
        role_name: localStorage.role_name,
        team_name: localStorage.team_name,
        dialog_loading: false,
        dialog_cso: false,
        arr_cso: [],
        form_cso: {
            case_id: "",
        },
        actibe_tab: "Pending Return",
        tabs_name: ["Pending Return", "Sent"],
        data_main: [],
        data_main_sub: [],
        data_main_mps: [],
        data_main_oki: [],
        data_main_svc: [],
        data_main_hp: [],
        checkbox: [],
        checkbox_sub: [],
        checkbox_mps: [],
        checkbox_oki: [],
        checkbox_svc: [],
        checkbox_hp: [],
        chk: false,
        chk_sub: false,
        chk_mpa: false,
        colorx: "",
        colorx_sub: "",
        colorx_mps: "",
        colorx_oki: "",
        colorx_svc: "",
        colorx_hp: "",
        text: "Success, Your work has been saved",
        tk: "",
        tab: false,
    }),
}
</script>
